import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { BoardComponent } from './components/board/board.component';
import { UserSecurityComponent } from './user-security/user-security.component';
import { UserAccessComponent } from './user-access/user-access.component';
import { AuthGuardService } from './auth-guard.service';
import { LoadDetailsComponent } from "./components/load-details/load-details.component";
import { EmergencyBolComponent } from "./components/app-modules/emergency-bol/emergency-bol.component";
import { WaitTimeOutComponent } from "./components/app-modules/wait-time-out/wait-time-out/wait-time-out.component";
import { DriverRouteSheetComponent } from "./components/driver-route-sheet/driver-route-sheet.component";
import { BillOfLadingComponent } from "./components/bill-of-lading/bill-of-lading.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
  },
  {
    path: "login",
    loadChildren: "./components/login/login.module#LoginModule",
  },
  {
    path: "signup",
    loadChildren: "./components/signup/signup.module#SignupModule",
  },
  {
    path: "dashboard",
    loadChildren: './components/app-modules/dashboard/dashboard.module#DashboardModule',
    canActivate: [AuthGuardService]
  },
  {
    path: "googlemaps",
    loadChildren: './components/app-modules/googlemaps/googlemaps.module#GooglemapsModule',
    canActivate: [AuthGuardService]
  },
  {
    path: "mechanic",
    loadChildren: './components/app-modules/mechanic/mechanic.module#MechanicModule',
    canActivate: [AuthGuardService]
  },
  {
    path: "stickreadings",
    loadChildren: './components/app-modules/stickreadings/stickreadings.module#StickreadingsModule',
    canActivate: [AuthGuardService]
  },
  {
    path: "device",
    loadChildren: () => import('./components/app-modules/device/device.module').then(m => m.DeviceModule),
    canActivate: [AuthGuardService]
  },
  {
    path: "tenant",
    loadChildren: () => import('./components/app-modules/tenant/tenant.module').then(m => m.TenantModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'access-control',
    loadChildren: () => import('./components/app-modules/access-control/access-control.module').then(m => m.AccessControlModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'map-comparison',
    loadChildren: './components/mapcomparison/mapcomparison.module#MapcomparisonModule',
    canActivate: [AuthGuardService]
  },
  {
    path: 'details-dashboard',
    loadChildren: () => import('./components/app-modules/details-dashboard/details-dashboard.module').then(m => m.DetailsDashboardModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'emergency-bol',
    component: EmergencyBolComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'load-details',
    // loadChildren: () => import('./components/load-details/load-details.module').then(m => m.LoadDetailsModule),
    component: LoadDetailsComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'wait-time-out',
    // loadChildren: () => import('./components/load-details/load-details.module').then(m => m.LoadDetailsModule),
    component: WaitTimeOutComponent,
    canActivate: [AuthGuardService]
  },



  //For subdomain it's temporary handling...
  {
    path: "newdashboard/login",
    loadChildren: "./components/login/login.module#LoginModule",
    canActivate: [AuthGuardService]
  },
  {
    path: "newdashboard/signup",
    loadChildren: "./components/signup/signup.module#SignupModule",
    canActivate: [AuthGuardService]
  },
  {
    path: "newdashboard/dashboard",
    loadChildren: './components/app-modules/dashboard/dashboard.module#DashboardModule',
    canActivate: [AuthGuardService]
  },
  {
    path: "newdashboard/googlemaps",
    loadChildren: () => import('./components/app-modules/googlemaps/googlemaps.module').then(m => m.GooglemapsModule),
    canActivate: [AuthGuardService]
  },
  {
    path: "newdashboard/mechanic",
    loadChildren: './components/app-modules/mechanic/mechanic.module#MechanicModule',
    canActivate: [AuthGuardService]
  },
  {
    path: "newdashboard/stickreadings",
    loadChildren: './components/app-modules/stickreadings/stickreadings.module#StickreadingsModule',
    canActivate: [AuthGuardService]
  },
  {
    path: "newdashboard/device",
    loadChildren: './components/app-modules/device/device.module#DeviceModule',
    canActivate: [AuthGuardService]
  },
  {
    path: "newdashboard/tenant",
    loadChildren: './components/app-modules/tenant/tenant.module#TenantModule',
    canActivate: [AuthGuardService]
  },
  {
    path: 'newdashboard/access-control',
    loadChildren: './components/app-modules/access-control/access-control.module#AccessControlModule',

    canActivate: [AuthGuardService]
  },
  {
    path: 'newdashboard/map-comparison',
    loadChildren: './components/mapcomparison/mapcomparison.module#MapcomparisonModule',
    canActivate: [AuthGuardService]
  },
  {
    path: 'newdashboard/details-dashboard',
    loadChildren: () => import('./components/app-modules/details-dashboard/details-dashboard.module').then(m => m.DetailsDashboardModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'error-control',
    loadChildren: () => import('./components/app-modules/errorcontrols/errorcontrols.module').then(m => m.ErrorcontrolsModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'ftp-checks',
    loadChildren: () => import('./components/app-modules/ftpcheck/ftpcheck.module').then(m => m.FtpcheckModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'board',
    component: BoardComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'user-security',
    component: UserSecurityComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'user-access',
    component: UserAccessComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'load-details',
    loadChildren: () => import('./components/load-details/load-details.module').then(m => m.LoadDetailsModule),
    canActivate: [AuthGuardService],

  },
  {
    path: 'driver-route-sheet',
    component: DriverRouteSheetComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'bill-of-lading',
    component: BillOfLadingComponent,
    canActivate: [AuthGuardService]
  },
  
  { path: "**", redirectTo: "not-found" }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
